import {getAbsoluteUrl} from "../../utils/urlUtill";

export function ConfigurableRedirectService($http) {
    const CONFIGURABLE_URL = getAbsoluteUrl('api/configurable_redirects');

    this.getRedirects = () => {
        return $http.get(CONFIGURABLE_URL);
    };

    this.saveRedirect = (redirectUrlData) => {
        return $http.post(CONFIGURABLE_URL, redirectUrlData);
    };

    this.deleteRedirect = (redirectId) => {
        return $http.delete(`${CONFIGURABLE_URL}/${redirectId}`);
    }
}